import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {lastValueFrom} from "rxjs";
import {NzMessageService} from "ng-zorro-antd/message";
import {
    DocumentTypeManageDto,
    FailedZonalTemplateCreateDto,
    PagingSearchDto,
    PerFormaAPIService
} from "src/app/services/pfapi.service";

@Component({
    selector: "app-zonal-template-failed-create",
    templateUrl: "./zonal-template-failed-create.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZonalTemplateFailedCreateComponent implements OnInit {
    form: FormGroup;
    documentTypes: DocumentTypeManageDto[] = [];
    saving = false;
    error = "";

    private scanDocumentId = 0;

    constructor(
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly api: PerFormaAPIService,
        private readonly msg: NzMessageService
    ) {
        this.form = this.fb.group({
            documentTypeId: [null, [Validators.required]],
            zonalTemplateName: ["", [Validators.required]]
        });
    }

    async ngOnInit() {
        this.scanDocumentId = Number(this.route.snapshot.queryParamMap.get("scanDocumentId")) || 0;

        const params: PagingSearchDto = {
            PageIndex: 1,
            PageSize: 1000,
            // empty sort uses the server default: Finance and Operations, then Equip, then alphabetical
            SortField: "",
            SortOrder: "ascend",
            SearchField: "",
            SearchValue: ""
        };
        const result = await lastValueFrom(this.api.postApiConfigureDocumentTypesSearch(params));
        this.documentTypes = result?.Data ?? [];
    }

    save = async () => {
        this.error = "";

        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }
        if (!this.scanDocumentId) {
            this.error = "No scan document specified.";
            return;
        }

        const dto: FailedZonalTemplateCreateDto = {
            ScanDocumentID: this.scanDocumentId,
            DocumentTypeID: this.form.value.documentTypeId,
            ZonalTemplateName: this.form.value.zonalTemplateName
        };

        this.saving = true;
        try {
            const templateId = await lastValueFrom(this.api.postApiConfigureZonalFailedTemplate(dto));
            this.msg.success("Template created.");
            await this.router.navigate(["/configure/zonaltemplateedit"], {queryParams: {templateId}});
        } catch (e) {
            this.error = this.extractError(e);
        } finally {
            this.saving = false;
        }
    };

    private extractError(err: unknown): string {
        const anyErr = err as {error?: {errors?: Record<string, string[]>; detail?: string}};
        const modelState = anyErr?.error?.errors;
        if (modelState && typeof modelState === "object") {
            const messages = (Object.values(modelState) as string[][]).flat();
            if (messages.length) return messages.join(" ");
        }
        return anyErr?.error?.detail || "Something went wrong.";
    }
}
